import api from './api';

const slaService = {
  async listPolicies() {
    return api.get('/api/sla/policies');
  },
  async createPolicy(payload) {
    return api.post('/api/sla/policies', payload);
  },
  async updatePolicy(id, payload) {
    return api.request(`/api/sla/policies/${id}`, { method: 'PATCH', body: payload });
  },
  async listRules(policyId) {
    return api.get(`/api/sla/policies/${policyId}/rules`);
  },
  async createRule(policyId, payload) {
    return api.post(`/api/sla/policies/${policyId}/rules`, payload);
  },
  async updateRule(policyId, ruleId, payload) {
    return api.request(`/api/sla/policies/${policyId}/rules/${ruleId}`, { method: 'PATCH', body: payload });
  }
};

export default slaService;

